import {MS_IN_DAY} from 'shared/const';

type LocalDate = Date;

function localStartOf(timestamp?: UnixTimeStamp): LocalDate {
  const date = new Date(timestamp);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function hasSameCalendarDate(first: UnixTimeStamp, second: UnixTimeStamp): boolean {
  const firstLocalStart = localStartOf(first);
  const secondLocalStart = localStartOf(second);
  return firstLocalStart.toString() === secondLocalStart.toString();
}

export function isToday(timestamp: UnixTimeStamp): boolean {
  return hasSameCalendarDate(timestamp, Date.now());
}

export function isYesterday(timestamp: UnixTimeStamp): boolean {
  return hasSameCalendarDate(timestamp, Date.now() - MS_IN_DAY);
}
